module.exports = __webpack_public_path__ + "86c8ce3f8f0ab5a6f95e232c1f89cdb9.svg";